// quantity-bundle.js
// Funcionalidade para o Bundle de Quantidade

class QuantityBundle {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.radioButtons = container.querySelectorAll('.quantity-bundle__radio');
    this.buyButton = container.querySelector('.quantity-bundle__buy-button');
    this.comparePriceEl = container.querySelector('.quantity-bundle__compare-price');
    this.comparePriceTextEl = container.querySelector('.quantity-bundle__compare-price-text');
    this.currentPriceEl = container.querySelector('.quantity-bundle__current-price');
    this.pixPriceEl = container.querySelector('.quantity-bundle__pix-price');
    
    this.baseComparePrice = parseFloat(this.comparePriceEl.dataset.comparePrice) / 100;
    this.baseCurrentPrice = parseFloat(this.currentPriceEl.dataset.currentPrice) / 100;
    this.pixDiscount = parseFloat(this.pixPriceEl.dataset.pixDiscount) || 1;
    
    // Capturar descontos por quantidade - versão robusta
    this.quantityDiscounts = {
      1: parseFloat(container.dataset.option3Discount || container.getAttribute('data-option-3-discount')) || 0,
      2: parseFloat(container.dataset.option2Discount || container.getAttribute('data-option-2-discount')) || 0,
      3: parseFloat(container.dataset.option1Discount || container.getAttribute('data-option-1-discount')) || 0
    };
    
    this.selectedQuantity = this.getSelectedQuantity();
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updatePrices();
    this.setupButton();
  }

  debugDiscounts() {
    // Debug para verificar se os descontos estão sendo capturados corretamente
    console.log('=== DEBUG QUANTITY BUNDLE ===');
    console.log('Container dataset completo:', this.container.dataset);
    console.log('option1Discount:', this.container.dataset.option1Discount);
    console.log('option2Discount:', this.container.dataset.option2Discount);
    console.log('option3Discount:', this.container.dataset.option3Discount);
    console.log('Descontos capturados:', this.quantityDiscounts);
    console.log('Preço base:', this.baseCurrentPrice);
    console.log('=============================');
  }

  setupButton() {
    // Salvar o texto e estilo original do botão
    this.originalButtonText = this.buyButton.textContent;
    this.originalButtonStyle = this.buyButton.style.background;
  }

  bindEvents() {
    // Event listener para mudança de quantidade
    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.selectedQuantity = parseInt(e.target.value);
        this.updatePrices();
        this.updateVisualSelection();
      });
    });

    // Event listener para botão de compra
    this.buyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.addToCart();
    });

    // Event listener para clique nas opções
    this.container.querySelectorAll('.quantity-bundle__option').forEach(option => {
      option.addEventListener('click', (e) => {
        if (e.target.type !== 'radio') {
          const radio = option.querySelector('.quantity-bundle__radio');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  }

  getSelectedQuantity() {
    const checkedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    return checkedRadio ? parseInt(checkedRadio.value) : 1;
  }

  updatePrices() {
    const quantity = this.selectedQuantity;
    
    // Obter desconto para a quantidade selecionada
    const quantityDiscountPercent = this.quantityDiscounts[quantity] || 0;
    const quantityDiscountDecimal = quantityDiscountPercent / 100;
    
    // Calcular preços totais
    const totalComparePrice = this.baseComparePrice * quantity;
    const totalCurrentPriceBeforeDiscount = this.baseCurrentPrice * quantity;
    
    // Aplicar desconto por quantidade
    const totalCurrentPrice = totalCurrentPriceBeforeDiscount * (1 - quantityDiscountDecimal);
    
    // Aplicar desconto do Pix em cima do preço já com desconto de quantidade
    const pixDiscountDecimal = this.pixDiscount / 100;
    const totalPixPrice = totalCurrentPrice * (1 - pixDiscountDecimal);

    // CORREÇÃO: Verificar se deve mostrar ou ocultar o preço comparativo
    // Só mostra se houver desconto (maior que 0%)
    if (quantityDiscountPercent > 0) {
      // Tem desconto - mostrar preço comparativo
      if (this.comparePriceTextEl) {
        this.comparePriceTextEl.style.display = '';
      }
      if (this.comparePriceEl) {
        this.comparePriceEl.style.display = '';
      }
    } else {
      // Não tem desconto (0%) - ocultar preço comparativo
      if (this.comparePriceTextEl) {
        this.comparePriceTextEl.style.display = 'none';
      }
      if (this.comparePriceEl) {
        this.comparePriceEl.style.display = 'none';
      }
    }

    // Atualizar elementos no DOM
    this.comparePriceEl.textContent = this.formatPrice(totalComparePrice);
    this.currentPriceEl.textContent = this.formatPrice(totalCurrentPrice);
    
    // Atualizar preço do Pix mantendo o texto original
    const pixText = this.pixPriceEl.textContent.split(' ').slice(-2).join(' '); // Pega "no pix"
    this.pixPriceEl.innerHTML = `${this.formatPrice(totalPixPrice)} ${pixText}`;
  }

  updateVisualSelection() {
    // Remove seleção visual de todas as opções
    this.container.querySelectorAll('.quantity-bundle__option').forEach(option => {
      option.classList.remove('quantity-bundle__option--selected');
    });

    // Adiciona seleção visual à opção ativa
    const selectedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    if (selectedRadio) {
      const selectedOption = selectedRadio.closest('.quantity-bundle__option');
      selectedOption.classList.add('quantity-bundle__option--selected');
    }
  }

  formatPrice(price) {
    return 'R$' + price.toFixed(2).replace('.', ',');
  }

  async addToCart() {
    // Prevenir múltiplas execuções
    if (this.buyButton.disabled) return;

    try {
      this.buyButton.disabled = true;
      this.buyButton.textContent = 'Adicionando...';

      // Buscar informações do produto
      const productData = await this.fetchProductData();
      const variantId = productData.variants[0].id; // Primeira variante disponível

      // Preparar dados do carrinho
      const cartData = {
        id: variantId,
        quantity: this.selectedQuantity,
        sections: this.getCartSections().join(','),
        sections_url: window.location.pathname
      };

      // Adicionar ao carrinho
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      });

      if (response.ok) {
        const responseData = await response.json();
        
        // Sucesso - mostrar feedback
        this.showSuccessFeedback();
        
        // Trigger evento customizado
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: responseData }
        }));
        
        // Redirecionar para o checkout após um pequeno delay
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 500);

      } else {
        throw new Error('Erro ao adicionar produto ao carrinho');
      }

    } catch (error) {
      console.error('Erro:', error);
      this.showErrorFeedback();
    }
  }

  async fetchProductData() {
    // Primeiro tentar buscar dados do produto que já estão disponíveis na página
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product;
    }

    // Fallback: buscar via handle na URL
    const handle = this.getProductHandle();
    if (handle) {
      const response = await fetch(`/products/${handle}.js`);
      return await response.json();
    }

    throw new Error('Não foi possível obter dados do produto');
  }

  getProductHandle() {
    // Tentar obter o handle do produto da URL
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/]+)/);
    return match ? match[1] : null;
  }

  showSuccessFeedback() {
    this.buyButton.textContent = '✓ Adicionado!';
    this.buyButton.style.background = '#4CAF50';
    
    // Restaurar botão após 2 segundos
    setTimeout(() => {
      this.restoreButton();
    }, 2000);
  }

  showErrorFeedback() {
    this.buyButton.textContent = 'Erro - Tente novamente';
    this.buyButton.style.background = '#f44336';
    
    // Restaurar botão após 3 segundos
    setTimeout(() => {
      this.restoreButton();
    }, 3000);
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.textContent = this.originalButtonText;
    this.buyButton.style.background = this.originalButtonStyle || '';
  }

  getCartSections() {
    return [
      'cart-drawer',
      'cart-icon-bubble'
    ];
  }

  async updateCartDrawer(responseData) {
    try {
      // Buscar o cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // Remover classe is-empty se existir
      cartDrawer.classList.remove('is-empty');

      // Se as sections vieram na resposta do add to cart, usar elas
      if (responseData.sections) {
        cartDrawer.renderContents({
          sections: responseData.sections,
          id: responseData.id
        });
      } else {
        // Caso contrário, buscar as sections separadamente
        const sectionsToRender = this.getCartSections();
        const sectionsData = {};
        
        for (const sectionId of sectionsToRender) {
          try {
            const sectionResponse = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
            if (sectionResponse.ok) {
              sectionsData[sectionId] = await sectionResponse.text();
            }
          } catch (error) {
            console.error(`Erro ao buscar seção ${sectionId}:`, error);
          }
        }

        cartDrawer.renderContents({
          sections: sectionsData,
          id: responseData.id
        });
      }
    } catch (error) {
      console.error('Erro ao atualizar cart drawer:', error);
    }
  }

  openCartDrawer() {
    // Usar o método específico do Dawn para abrir o cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      // Abrir o drawer diretamente
      cartDrawer.open();
    } else {
      // Fallback: trigger do ícone do carrinho
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.click();
      }
    }
  }
}

// Inicialização quando o DOM estiver pronto
function initQuantityBundles() {
  const bundles = document.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
}

// Auto-inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityBundles);
} else {
  initQuantityBundles();
}

// Re-inicializar quando seções forem carregadas dinamicamente (Theme Editor)
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const bundles = section.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
});

// Limpar quando seções forem removidas
document.addEventListener('shopify:section:unload', (event) => {
  // Cleanup se necessário (event listeners são automaticamente removidos quando elementos são removidos do DOM)
});

// Exportar para uso global se necessário
window.QuantityBundle = QuantityBundle;

// ============ VERSÃO COM CLEAR MAIS RÁPIDO ============
(function() {
  const GIFT_CONFIG = {
    melатониnaVariantId: 48159143723237,
    triggerQuantities: [2, 3]
  };

  QuantityBundle.prototype.addToCart = async function() {
    if (this.buyButton.disabled) return;

    this.buyButton.disabled = true;
    this.buyButton.textContent = 'Processando...';

    try {
      const productData = await this.fetchProductData();
      const variantId = productData.variants[0].id;

      // Limpar carrinho primeiro
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      // Adicionar produto principal e verificar resposta
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: this.selectedQuantity }]
        })
      });

      if (!addResponse.ok) {
        throw new Error('Falha ao adicionar produto ao carrinho');
      }

      // Tentar adicionar brinde separadamente (se falhar, não impede o checkout)
      if (GIFT_CONFIG.triggerQuantities.includes(this.selectedQuantity)) {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: GIFT_CONFIG.melатониnaVariantId,
                quantity: 1,
                properties: { '_Brinde': '🎁 Melatonina Grátis' }
              }]
            })
          });
        } catch (giftError) {
          console.warn('Brinde não pôde ser adicionado:', giftError);
        }
      }

      window.location.href = '/checkout';

    } catch (error) {
      console.error('Erro:', error);
      this.buyButton.disabled = false;
      this.buyButton.textContent = 'Erro - Tente novamente';
      setTimeout(() => {
        this.buyButton.textContent = this.originalButtonText;
      }, 3000);
    }
  };
})();